import React from 'react';
import '../App.css';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext.jsx';
import { useEffect, useState, useCallback } from "react";
import axios from 'axios';
import ReportedUserModal from '../components/reportedUserModal.js';

function AdminUsersTab() {
    const { backendApiBaseUrl } = useConfig();
    const { id, token } = useAuth();
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [showReportModal, setShowReportModal] = useState(false);
    const [searchedUser, setSearchedUser] = useState(null);
    const [searchType, setSearchType] = useState('ID');
    const [searchValue, setSearchValue] = useState('');
    const [showItems, setShowItems] = useState(false);
    const [morphImageIndex, setMorphImageIndex] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [updatingRole, setUpdatingRole] = useState(false);


    const isSearching = searchValue.trim().length > 0;


    const [filters, setFilters] = useState({
        status: 'PENDING',
        sort: 'oldest'
    });

    const fetchData = useCallback(async (pageToFetch = 1, reset = false) => {
        setLoading(true);
        
        try {
            const url = new URL(`${backendApiBaseUrl}/admin/reports/user`);

            const response = await axios.post(url.toString(), {
                userId: id,
				page: pageToFetch,
                pageSize: 20,
                status: filters.status,
                sort: filters.sort,
			},
			{
				headers: {
					"Authorization": `Bearer ${token.token}`,
				}
			});

            const { data = [], pagination } = response.data;

            if (!pagination) {
                console.error('Missing pagination in response', response.data);
                setHasMore(false);
                return;
            }

            setItems(prev => reset ? data : [...prev, ...data]);

            setHasMore(pagination.hasNextPage);
            setPage(pageToFetch);

        } catch (error) {
            console.error('Error fetching reports:', error);
        } finally {
            setLoading(false);
        }

    }, [ backendApiBaseUrl, filters, id, token]);


    useEffect(() => {
        setItems([]);
        setPage(1);
        setHasMore(true);
        fetchData(1, true);
    }, [filters, fetchData]);


    const fetchMoreData = () => {
        if (!hasMore || loading) return;
        fetchData(page + 1);
    };

    const handleSort = (value) => {
        setFilters(prevFilters => ({ ...prevFilters, sort: value }));
    };

    const getReportedItemDetails = async (item) => {
        try {
            const url = new URL(`${backendApiBaseUrl}/moderation/reports/details`);
            
            const response = await axios.post(url.toString(), {
                reportId: item.id,
			},
			{
				headers: {
					"Authorization": `Bearer ${token.token}`,
				}
			});

            const { itemDetails, report, otherReports } = response.data.data;
            setSelectedReport({
                report,
                item: itemDetails,
                itemType: report.itemType,
                otherReports: otherReports
            });

            setShowReportModal(true);
        }
        catch (error) {
            console.error('Error fetching reported item details:', error);
        }
    };

    const handleCloseModal = () => {
        setSelectedReport(null);
		setShowReportModal(false);
    };

    const onSubmitReport = async(reportData) => {
        console.log('Report Data in activity:', reportData);
        const reportUrl = new URL(`${backendApiBaseUrl}/reports`);

        const response = await axios.post(reportUrl.toString(), {
            reportData
        });

        console.log('Report Response:', response.data);
    };

    const updateReport = async(updateData) => {
        const updateURL = new URL(`${backendApiBaseUrl}/moderation/reports/update`)

        await axios.post(updateURL.toString(), {
            updateData
        },
        {
            headers: {
                "Authorization": `Bearer ${token.token}`,
            }
        });

        fetchData(1, true);
    }

    const searchUser = async() => {

        const searchURL = new URL(`${backendApiBaseUrl}/admin/search/user`)

        const response = await axios.post(searchURL.toString(), {
            searchUserData: {
                searchType,
                searchValue
            }
        },
        {
            headers: {
                "Authorization": `Bearer ${token.token}`,
            }
        });


        const user = response.data;

        setSearchedUser(user.user)
        console.log('Searched User: ', searchedUser);
    }

    const updateUserRole = async(updateData) => {
        const updateURL = new URL(`${backendApiBaseUrl}/admin/update/user`)

        await axios.post(updateURL.toString(), {
            updateData
        },
        {
            headers: {
                "Authorization": `Bearer ${token.token}`,
            }
        });
    }

    const handleNextMorphImage = (morphId, imageCount) => {
        setMorphImageIndex(prev => {
            const currentIndex = prev[morphId] ?? 0;
            const nextIndex = (currentIndex + 1) % imageCount;

            return {
                ...prev,
                [morphId]: nextIndex
            };
        });
    };


    return (
        <div>
            <div className='d-flex justify-content-between align-items-center px-4'>
                <div className="d-flex align-items-center gap-2">
                <label className="text-white mb-0">Search user</label>

                <select
                    className="form-select"
                    style={{ width: '130px', color: 'black' }}
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                >
                    <option value="ID" style={{ color: 'black' }}>User ID</option>
                    <option value="USERNAME" style={{ color: 'black' }}>Username</option>
                </select>

                <input
                    className="form-control"
                    style={{ width: '220px' }}
                    value={searchValue}
                    placeholder={
                        searchType === 'ID'
                            ? 'Enter user ID'
                            : 'Enter username'
                    }
                    onChange={(e) => setSearchValue(e.target.value)}
                />

                <button
                    className="btn btn-outline-light"
                    onClick={() =>
                        searchUser({
                            type: searchType,
                            value: searchValue.trim(),
                        })
                    }
                    disabled={!searchValue.trim()}
                >
                    Search
                </button>
            </div>
                <div className="p-2">
                    <select className="form-select"  value={filters.sort} style={{color:"black"}} onChange={(e) => handleSort(e.target.value)}>
                        <option className='profile-filter-dropdown' value="newest">Newest</option>
                        <option className='profile-filter-dropdown' value="oldest">Oldest</option>
                    </select>
                </div>
            </div>

            
            <div>
                {isSearching && searchedUser && (
                    <div className="card" style={{ backgroundColor: "#313338" }}>
                        <div className="card-body d-flex align-items-center gap-4 py-2 border-bottom">
                            <div>
                                <strong>{searchedUser.username}</strong>
                            </div>
                            <div>
                                <span className="me-1">Role: </span>
                                {searchedUser.role}
                            </div>
                            <div>
                                <span className="me-1">Morphs: </span>
                                {searchedUser.morphs?.length ?? 0}
                            </div>
                            <div>
                                <span className="text-bold me-1">Sketches: </span>
                                {searchedUser.sketches?.length ?? 0}
                            </div>
                            <button type="button" className="btn btn-dark btn-sm"  onClick={() => setShowItems(!showItems)}> See Items</button>

                            <div className="d-flex align-items-center gap-2 ms-auto">
                                <label className="mb-0 small">Update Role</label>
                                <select
                                    className="form-select form-select-sm"
                                    style={{ maxWidth: '160px' }}
                                    value={selectedRole}
                                    onChange={(e) => setSelectedRole(e.target.value)}
                                >
                                    <option value="" style={{ color: 'black' }}>Select</option>
                                    <option value="ADMIN" style={{ color: 'black' }}>ADMIN</option>
                                    <option value="MODERATOR" style={{ color: 'black' }}>MODERATOR</option>
                                    <option value="DEV" style={{ color: 'black' }}>DEV</option>
                                    <option value="BAND" style={{ color: 'black' }}>BAND</option>
                                    <option value="TESTER" style={{ color: 'black' }}>TESTER</option>
                                </select>
                            </div>

                            <button
                                type="button"
                                className="btn btn-outline-light btn-sm mx-2"
                                disabled={!selectedRole || updatingRole}
                                onClick={async () => {
                                    try {
                                        setUpdatingRole(true);

                                        await updateUserRole({
                                            userId: searchedUser.id,
                                            role: selectedRole,
                                        });

                                        searchUser()

                                        setSelectedRole('');
                                    } finally {
                                        setUpdatingRole(false);
                                    }
                                }}
                            >
                                {updatingRole ? 'Updating...' : 'Update'}
                            </button>

                        </div>
                        <div className='mb-4'>
                        {showItems && (
                            <div className="d-flex justify-content-center">
                                <div style={{ maxWidth: "300px" }}>
                                    {searchedUser.morphs.map(item => {
                                        const currentIndex = morphImageIndex[item.id] ?? 0;

                                        return (
                                            <div key={item.id} className="scroll-item">
                                                <div className="image-container">
                                                    {item.images.length > 0 && (
                                                        <img
                                                            src={item.images[currentIndex].presignedUrl}
                                                            alt="Item Preview"
                                                            style={{
                                                                maxWidth: '100%',
                                                                paddingBottom: '10px',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() =>
                                                                handleNextMorphImage(item.id, item.images.length)
                                                            }
                                                        />
                                                    )}

                                                    <div
                                                        className="card-body m-0 p-0"
                                                        style={{
                                                            wordBreak: 'break-word',
                                                            overflowWrap: 'anywhere'
                                                        }}
                                                    >
                                                        <p>{item.description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}

                                </div>
                                <div style={{ maxWidth: "300px" }}>
                                {searchedUser.sketches.map(item => (
									<div key={item.eventId} className="scroll-item">
										<div className="image-container">
                                            <img
                                                src={item.presignedUrl}
                                                alt="Item Preview"
                                                style={{ maxWidth: '100%', paddingBottom: '10px' }}
                                            />
											<div className="card-body m-0 p-0" style={{ wordBreak: 'break-word', overflowWrap: 'anywhere'}}>
                                                <div className='d-flex flex-column p-0'>
                                                    <p>Code: {item.cardCode}</p>
                                                    <p>{item.character}</p>
                                                </div>
                                                
                                                <p>{item.description}</p>
											</div>
										</div>
									</div>
                                ))}
                                </div>
                            </div>
                        )}
                        </div>
                    </div>

                )}
                {!isSearching && (
                    <div>
                        {items.length === 0 ? (
                            <div className="text-center mt-4" style={{  color:"#FFF" }}>
                                No items found
                            </div>
                        ) : (
                            <InfiniteScroll
                                    dataLength={items.length}
                                    next={fetchMoreData}
                                    hasMore={hasMore}
                                    loader={<h4>Loading...</h4>}
                                    scrollableTarget="infiniteScrollContainer"
                                >
                                {items.length === 0 && !loading && (
                                    <div className="text-center mt-4 text-white">
                                    No reports found
                                    </div>
                                )}
                                <div className="d-flex px-3 py-2 p fw-bold border-bottom text-muted">
                                    <div style={{ flex: 2 }}>Reporter</div>
                                    <div style={{ flex: 1 }}>Type</div>
                                    <div style={{ flex: 3 }}>Reason</div>
                                    <div style={{ flex: 1 }}>Status</div>
                                    <div style={{ flex: 1 }}>Actions</div>
                                </div>
                                {items.map(item => (
                                    <div key={item.id} className="moderation-row d-flex align-items-center px-3 py-2 border-bottom">
                                        <div style={{ flex: 2 }}>
                                            {item.reporter.username}
                                        </div>

                                        <div style={{ flex: 1 }}>
                                            {item.itemType}
                                        </div>

                                        <div style={{ flex: 3 }}>
                                            {item.reason}
                                        </div>

                                        <div style={{ flex: 1 }}>
                                            {item.status}
                                        </div>
                                        
                                        <div style={{ flex: 1 }}>
                                            <button
                                                className="btn btn-sm btn-outline-light"
                                                onClick={() => getReportedItemDetails(item)}
                                            >
                                                Review
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </InfiniteScroll>
                        )}
                        {showReportModal && (
                            <ReportedUserModal
                                open={showReportModal}
                                onClose={handleCloseModal}
                                show={selectedReport !== null}
                                report={selectedReport?.report}
                                item={selectedReport?.item}
                                itemType={selectedReport?.itemType}
                                otherReports={selectedReport?.otherReports}
                                onSubmitReport={onSubmitReport}
                                id={id}
                                updateReport={updateReport}
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
	);
}

export default AdminUsersTab;